import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  OutlinedInput,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useState } from "react";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const PaymentTermsFilter = (props) => {
  const {
    handleAddDialogOpen,
    handleSearch,
    handleSearchCode,
    handleSearchCondition,
  } = props;
  const [code, setCode] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");
  return (
    <>
      <Box className="p-24" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <div className="flex">
              <FormControl className="flex flex-row">
                {/* <div className="mr-16">
                  <label>Code</label>
                  <StyledTextField
                    type="text"
                    name="code"
                    value={code}
                    onChange={(e) => {setCode(e.target.value); handleSearchCode(e.target.value.toUpperCase())}}
                    variant="outlined"
                    fullWidth
                    sx={{ input: { textTransform: "uppercase" } }}
                  />
                </div> */}
                <div className="mr-16">
                  {/* <label>Search Code or Payment Condition</label> */}
                  <StyledOutlinedInput
                    type="text"
                    name="paymentCondition"
                    placeholder="Search Code or Payment..."
                    value={paymentCondition}
                    onChange={(e) => {setPaymentCondition(e.target.value); handleSearch(e.target.value)}}
                    variant="outlined"
                    fullWidth
                    endAdornment={<InputAdornment position="end"><FuseSvgIcon>heroicons-outline:search</FuseSvgIcon></InputAdornment>}
                  />
                </div>
              </FormControl>
            </div>
          </Grid>
          {/* <Grid item xs={4} className="flex justify-end">
            <Button
              color="warning"
              variant="contained"
              startIcon={
                <FuseSvgIcon size={18}>heroicons-outline:plus</FuseSvgIcon>
              }
              onClick={handleAddDialogOpen}
            >
              Add
            </Button>
          </Grid> */}
        </Grid>
      </Box>
    </>
  );
};

export default PaymentTermsFilter;
